import { SettingService } from './../../../services/setting.service';
import { NotifyService } from 'src/app/services/notify.service';
import { MappingNodeService } from './../../../services/mapping-node.service';
import { Component, OnInit } from '@angular/core';
import { NodeDataService } from 'src/app/services/node-data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { saveAs as importedSaveAs } from 'file-saver';
import { TimeoutError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { timeout, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-mapping-import-modal',
  templateUrl: './mapping-import-modal.component.html',
  styleUrls: ['./mapping-import-modal.component.css']
})
export class MappingImportModalComponent implements OnInit {

  nodeId: any;
  fileName: string;
  allowFileTypes = ['xlsx'];
  file: File;
  isSuccess: boolean;
  countDuplicate: any;
  countSuccess: any;
  countError: any;

  sourceId: any;
  destinationId: any;
  countNotFound: any;
  progress = 0;
  isWaiting = false;
  limitFilSizeValue = 0;
  fileSizeInvalid: boolean;
  countApprove: any;
  isSelected: boolean = false;
  showWarning: boolean = false;
  splitMapping;
  constructor(public activeModal: NgbActiveModal,
              private toastr: ToastrService,
              private mappingNodeService: MappingNodeService,
              private notifyService: NotifyService,
              private settingService: SettingService) { }

  ngOnInit() {
    this.notifyService.importMapping.subscribe(res => {
      this.progress = res;
    });
    this.settingService.get({name: 'FileSize'}).subscribe((res: any) => {
      if (res) {
        this.limitFilSizeValue = res.value;
      }
    });
  }

  closeModal(action: string) {
    this.activeModal.close(action);
  }

  onFileChange(event) {
    this.isSelected = true;
    this.fileSizeInvalid = false;
    const target = event.target as HTMLInputElement;
    if (target.files && target.files[0]) {
      if (!this.validateFile(target.files[0].name)) {
        this.toastr.error('Selected file format is not supported');
        return false;
      }
      const fileSize = target.files[0].size / 1024 / 1024;
      if (fileSize > this.limitFilSizeValue) {
        this.fileSizeInvalid = true;
      } else {
        this.file = target.files[0];
        this.fileName = target.files[0].name;
      }
    }
  }

  validateFile(name) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    if (this.allowFileTypes.indexOf(ext.toLowerCase()) > -1) {
        return true;
    } else {
        return false;
    }
  }

  upload() {
    // if (this.splitMapping == undefined) {
    //   this.splitMapping = false;
    // }
    if (this.isSelected) {
      this.showWarning = false;
      this.isWaiting = true;
      this.progress = 0;
      const data = new FormData();
      data.append('FileImport', this.file);
      data.append('SourceId', this.sourceId);
      data.append('DestinationId', this.destinationId);
      // split mapping will always be true, when create mapping by import
      data.append('SplitMapping', 'true');
      data.append('OriginURL', window.location.origin);
      this.isSuccess = false;
      this.mappingNodeService.import(data).subscribe((res: any) => {
        this.toastr.success('Import success.');
        this.isSuccess = true;
        this.countDuplicate = res.countDuplicate;
        this.countApprove = res.countApprove;
        this.countError = res.countError;
        this.countSuccess = res.countSuccess;
        this.countNotFound = res.countNotFound;
        if (this.countDuplicate > 0 || this.countError > 0 ||  this.countNotFound ) {
          const byteArray = new Uint8Array(res.file);
          const blob = this.FileContenttoBlob(res.file, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          importedSaveAs(blob, 'ErrorData.xlsx');
        }
      }, error => {
        if (+error.status === 504) { // timeout
          // tslint:disable-next-line:max-line-length
          this.toastr.info('Server กำลังประมวลผล ซึ่งอาจใช้เวลานาน กรุณาปิดหน้านี้แล้วรอแจ้งผลการทำงานในเมนู Notification', '', {disableTimeOut: true})
            .onHidden.subscribe(x => {
              this.closeModal('upload');
            });
        }
      });
    } else { 
      this.showWarning = true;
    }
  }

  public base64toBlob(base64Data) {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays);
  }

  public  FileContenttoBlob(fileContent, fileType) {
    const sliceSize = 1024;
    const byteCharacters = atob(fileContent);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: fileType});
  }

  donwloadTemplate() {
    // tslint:disable-next-line:max-line-length
    this.mappingNodeService.downloadTemplate(this.sourceId, this.destinationId).subscribe((blob: any) => {
      importedSaveAs(blob, 'MappingTemplate');
    });
  }
}
